export enum BuildActionType {
    BUILD = "BUILD",
    DESTROY = "DESTORY"
}